import { render, staticRenderFns } from "./NotificationsPullout.vue?vue&type=template&id=0581d9bb&scoped=true&"
import script from "./NotificationsPullout.vue?vue&type=script&lang=js&"
export * from "./NotificationsPullout.vue?vue&type=script&lang=js&"
import style0 from "./NotificationsPullout.vue?vue&type=style&index=0&id=0581d9bb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0581d9bb",
  null
  
)

export default component.exports